import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Column from '../../../../shared/components/atoms/Column';
import CardRow from '../../../../shared/components/molecules/CardRow';
import { IAppState } from '../../../../reducers';
import { EmailSummary } from '../../shared/components/SummaryTextHelper';

type Props = {
  className?: string;
  theme: {
    colours: {
      grey50: string;
    };
  };
};

export const Summary: FunctionComponent<React.PropsWithChildren<Props>> = ({ className }) => {
  const ddosProtectionTier = useSelector((state: IAppState) => state.quoteBuilder.quote.ddosProtection);
  const ddosProtection = useSelector((state: IAppState) => state.orderBuilder.order.ddosProtection);

  // Only show Email2 and Email3 for Tier 2, or 3
  const showAdditionalEmails = ["Tier 2", "Tier 3"].includes(ddosProtectionTier ?? "");

  return (
    <CardRow className={className} title="">
      <div className="row no-gutters">
        <Column defaultWidth={4}>
          <p>Reporting Emails</p>
        </Column>
        <Column defaultWidth={4}>
          <p className="lighter-text">Reporting Email 1</p>
        </Column>
        <Column defaultWidth={4}>
            <EmailSummary email={ddosProtection?.reportingEmail1 ?? ""} />
        </Column>
      </div>

      {showAdditionalEmails && (
        <div className="row no-gutters">
          <Column defaultWidth={4} offsetDefaultWidth={4}>
            <p className="lighter-text">Reporting Email 2</p>
          </Column>
          <Column defaultWidth={4}>
              <EmailSummary email={ddosProtection?.reportingEmail2 ?? ""} required={false} />
          </Column>
        </div>
      )}

      {showAdditionalEmails && (
        <div className="row no-gutters">
          <Column defaultWidth={4} offsetDefaultWidth={4}>
            <p className="lighter-text">Reporting Email 3</p>
          </Column>
          <Column defaultWidth={4}>
              <EmailSummary email={ddosProtection?.reportingEmail3 ?? ""} required={false} />
          </Column>
        </div>
      )}

      {/* Portal Access - Disabled for v1 */}
      {false && ( //showAdditionalEmails
        <div className="row no-gutters mt-3">
          <Column defaultWidth={4}>
            <p className="pb-0">Portal Access Emails</p>
          </Column>
          <Column defaultWidth={8}>
            <div className="row no-gutters">
              <Column defaultWidth={6}>
                <p className="lighter-text">Portal Access Email 1</p>
              </Column>
              <Column defaultWidth={6}>
                <EmailSummary email={ddosProtection?.portalAccessEmail1 ?? ""} />
              </Column>
            </div>
            <div className="row no-gutters">
              <Column defaultWidth={6}>
                <p className="lighter-text">Portal Access Email 2</p>
              </Column>
              <Column defaultWidth={6}>
                  <EmailSummary email={ddosProtection?.portalAccessEmail2 ?? ""} required={false} />
              </Column>
            </div>
            <div className="row no-gutters">
              <Column defaultWidth={6}>
                <p className="lighter-text">Portal Access Email 3</p>
              </Column>
              <Column defaultWidth={6}>
                <EmailSummary email={ddosProtection?.portalAccessEmail3 ?? ""} required={false} />
              </Column>
            </div>
          </Column>
        </div>
      )}
    </CardRow>
  );
};

export default styled(Summary)`
  .lighter-text {
    color: ${(props) => props.theme.colours.grey50};
  }

  .text-summary {
    word-break: break-all;
  }
`;
